import type { FC } from "react";
import React from "react";
import {
  Body,
  Box,
  Button,
  Flex,
  Heading,
  ModalContent,
  SystemModal,
  SystemModalHeader,
  SystemModalIcon,
  Glyph,
} from "@edreamsodigeo/prisma-design-system";
import {
  useTrackElement,
  useTranslation,
  useBrokenFlowModal,
  useFlow,
} from "@edreamsodigeo/frontend-core";

export const HTML_EVENT_DISPLAY_ID = "broken-flow-modal-fallback";

const BrokenFlowContent: FC = () => {
  const { close } = useBrokenFlowModal();
  const { t } = useTranslation();
  const ref = useTrackElement<HTMLDivElement>(
    ["display"],
    HTML_EVENT_DISPLAY_ID,
  );
  const onClickGoToHome = (): void => {
    close?.();
    window.location.assign("/");
  };

  return (
    <ModalContent>
      <Box px="1x_big" pb="1x_big" ref={ref}>
        <div>
          <Heading type="2" textAlign="center" color="neutral.90">
            {t("brokenFlow.heading")}
          </Heading>
        </div>
        <Box pt="small">
          <Body textAlign="center" type="base" color="neutral.80">
            {t("brokenFlow.description")}
          </Body>
        </Box>
        <Flex justifyContent="center" alignItems="center">
          <Box width={{ _: "100%", md: "60%" }}>
            <Box pt="1x_big">
              <Button onClick={onClickGoToHome} fullWidth type="primary">
                {t("brokenFlow.link")}
              </Button>
            </Box>
          </Box>
        </Flex>
      </Box>
    </ModalContent>
  );
};

const BrokenFlowModal: FC = () => {
  const { isOpen } = useBrokenFlowModal();
  const flow = useFlow();

  return (
    <SystemModal modalSize={flow === "mobile" ? "full" : "large"} open={isOpen}>
      <SystemModalHeader type="warning">
        <SystemModalIcon>
          <Glyph
            size="medium"
            color="orange.50"
            category="Alerts"
            name="Warning"
          />
        </SystemModalIcon>
      </SystemModalHeader>
      <BrokenFlowContent />
    </SystemModal>
  );
};

export default BrokenFlowModal;
